import { logError } from "./log.js";

if (process.env.NODE_ENV === "production") {
	globalThis.window?.addEventListener("error", (event) => {
		if (typeof event === "object" && "error" in event) {
			logError(event.error);
		} else if (typeof event === "object" && "message" in event) {
			logError(event);
		}
	});
}
